import { UrlConstant } from "../../urlConstant/UrlConstant"
import useCallBack, { Callbacks } from "../../utils/callback/useCallBack"
import { useHttpRequest } from "../../utils/httpRequest"

export const AuthenticateUserMutation = <T>(variables: any, callbacks?: Callbacks<T>) => {
    const { onError, onLoading, onSuccess } = useCallBack<T>(callbacks)
    const authenticate = async () => {
            try {
                const headers = {
                    "Content-Type": "application/json",
                }
                const { postRequest } = useHttpRequest({omitToken:true})
                const response = await postRequest(`/${UrlConstant.Auth}/${UrlConstant.Login}`, variables)

                const data = await response
                return data
            }
            catch (error: any) {
                onError(error as Error)
            }
        }
    (async () => {
        
        try {
            const response = await authenticate()
            if (response) {
                if (response.succeeded) {
                    onSuccess(response)
                } else {
                    onError({message:response.message,name:''})
                }
            }

        } catch (error: any) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    })()
}
